export function patchScrollBlockingListeners(): void {
  let supportsPassive = false;
  const x = document.createElement("x");
  x.addEventListener("cut", () => 1, {
    get passive() {
      supportsPassive = true;
      return !!1;
    },
  });
  x.remove();
  if (supportsPassive) {
    const originalFn = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (...args) {
      if (
        ["scroll", "touchmove", "touchstart"].includes(args[0]) &&
        (typeof args[2] !== "object" || args[2].passive === undefined)
      ) {
        args[2] = {
          ...(typeof args[2] === "object" ? args[2] : {}),
          passive: typeof args[2] === "boolean" ? args[2] : true,
        };
      }
      originalFn.call(this, ...args);
    };
  }
}
